import { isPopulatedString } from 'src/app/utils/isPopulatedString';
import { isPositiveNumber } from 'src/app/utils/isPositiveNumber';
import type { SuggestedSalary as GraphqlSuggestedSalary } from 'src/graphql/generated';
import type { SuggestedSalary } from 'src/types/salaryTypes';

export const mapResponse = (
  data?: GraphqlSuggestedSalary | null,
): SuggestedSalary | null => {
  if (
    !data ||
    !data.location ||
    !data.roleTitle ||
    !data.currency ||
    !data.range ||
    !data.averageRange
  ) {
    return null;
  }

  const isValid =
    isPositiveNumber(data.range.min) &&
    isPositiveNumber(data.range.max) &&
    isPositiveNumber(data.averageRange.min) &&
    isPositiveNumber(data.averageRange.max) &&
    isPopulatedString(data.location) &&
    isPopulatedString(data.roleTitle) &&
    isPopulatedString(data.currency);

  if (!isValid) {
    return null;
  }

  return {
    min: data.range.min,
    max: data.range.max,
    averageMin: data.averageRange.min,
    averageMax: data.averageRange.max,
    location: data.location,
    roleTitle: data.roleTitle,
    currency: data.currency,
  };
};
